"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_qln2pae0b = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/FileCard.js";
  var hash = "a02c4029e7d2b595f9b2c25dc9e70a7f66c3faf2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/FileCard.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "1": {
        start: {
          line: 13,
          column: 39
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "2": {
        start: {
          line: 29,
          column: 18
        },
        end: {
          line: 29,
          column: 29
        }
      },
      "3": {
        start: {
          line: 30,
          column: 32
        },
        end: {
          line: 30,
          column: 46
        }
      },
      "4": {
        start: {
          line: 31,
          column: 34
        },
        end: {
          line: 31,
          column: 68
        }
      },
      "5": {
        start: {
          line: 32,
          column: 19
        },
        end: {
          line: 32,
          column: 54
        }
      },
      "6": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 33,
          column: 72
        }
      },
      "7": {
        start: {
          line: 34,
          column: 17
        },
        end: {
          line: 34,
          column: 44
        }
      },
      "8": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 38,
          column: 13
        }
      },
      "9": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 38
        }
      },
      "10": {
        start: {
          line: 40,
          column: 17
        },
        end: {
          line: 40,
          column: 80
        }
      },
      "11": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 97,
          column: 4
        }
      },
      "12": {
        start: {
          line: 61,
          column: 85
        },
        end: {
          line: 61,
          column: 105
        }
      },
      "13": {
        start: {
          line: 69,
          column: 14
        },
        end: {
          line: 69,
          column: 47
        }
      },
      "14": {
        start: {
          line: 69,
          column: 27
        },
        end: {
          line: 69,
          column: 47
        }
      },
      "15": {
        start: {
          line: 79,
          column: 35
        },
        end: {
          line: 81,
          column: 15
        }
      },
      "16": {
        start: {
          line: 83,
          column: 14
        },
        end: {
          line: 83,
          column: 57
        }
      },
      "17": {
        start: {
          line: 83,
          column: 32
        },
        end: {
          line: 83,
          column: 57
        }
      },
      "18": {
        start: {
          line: 100,
          column: 0
        },
        end: {
          line: 125,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 29
          },
          end: {
            line: 13,
            column: 30
          }
        },
        loc: {
          start: {
            line: 13,
            column: 39
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "FileCard",
        decl: {
          start: {
            line: 24,
            column: 9
          },
          end: {
            line: 24,
            column: 17
          }
        },
        loc: {
          start: {
            line: 28,
            column: 3
          },
          end: {
            line: 98,
            column: 1
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 36,
            column: 12
          },
          end: {
            line: 36,
            column: 13
          }
        },
        loc: {
          start: {
            line: 36,
            column: 18
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 36
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 61,
            column: 79
          },
          end: {
            line: 61,
            column: 80
          }
        },
        loc: {
          start: {
            line: 61,
            column: 85
          },
          end: {
            line: 61,
            column: 105
          }
        },
        line: 61
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 68,
            column: 21
          },
          end: {
            line: 68,
            column: 22
          }
        },
        loc: {
          start: {
            line: 68,
            column: 27
          },
          end: {
            line: 70,
            column: 13
          }
        },
        line: 68
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 78,
            column: 21
          },
          end: {
            line: 78,
            column: 22
          }
        },
        loc: {
          start: {
            line: 78,
            column: 27
          },
          end: {
            line: 84,
            column: 13
          }
        },
        line: 78
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 43
          },
          end: {
            line: 31,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 31,
            column: 50
          },
          end: {
            line: 31,
            column: 62
          }
        }, {
          start: {
            line: 31,
            column: 65
          },
          end: {
            line: 31,
            column: 67
          }
        }],
        line: 31
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 33
          },
          end: {
            line: 32,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 33
          },
          end: {
            line: 32,
            column: 37
          }
        }, {
          start: {
            line: 32,
            column: 41
          },
          end: {
            line: 32,
            column: 53
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 41
          }
        }, {
          start: {
            line: 33,
            column: 45
          },
          end: {
            line: 33,
            column: 72
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 37,
            column: 16
          },
          end: {
            line: 37,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 16
          },
          end: {
            line: 37,
            column: 20
          }
        }, {
          start: {
            line: 37,
            column: 24
          },
          end: {
            line: 37,
            column: 36
          }
        }],
        line: 37
      },
      "4": {
        loc: {
          start: {
            line: 40,
            column: 17
          },
          end: {
            line: 40,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 41
          },
          end: {
            line: 40,
            column: 52
          }
        }, {
          start: {
            line: 40,
            column: 55
          },
          end: {
            line: 40,
            column: 80
          }
        }],
        line: 40
      },
      "5": {
        loc: {
          start: {
            line: 40,
            column: 18
          },
          end: {
            line: 40,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 18
          },
          end: {
            line: 40,
            column: 22
          }
        }, {
          start: {
            line: 40,
            column: 26
          },
          end: {
            line: 40,
            column: 37
          }
        }],
        line: 40
      },
      "6": {
        loc: {
          start: {
            line: 46,
            column: 24
          },
          end: {
            line: 46,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 24
          },
          end: {
            line: 46,
            column: 28
          }
        }, {
          start: {
            line: 46,
            column: 32
          },
          end: {
            line: 46,
            column: 41
          }
        }],
        line: 46
      },
      "7": {
        loc: {
          start: {
            line: 62,
            column: 13
          },
          end: {
            line: 62,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 24
          },
          end: {
            line: 62,
            column: 36
          }
        }, {
          start: {
            line: 62,
            column: 39
          },
          end: {
            line: 62,
            column: 59
          }
        }],
        line: 62
      },
      "8": {
        loc: {
          start: {
            line: 69,
            column: 14
          },
          end: {
            line: 69,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 14
          },
          end: {
            line: 69,
            column: 47
          }
        }, {
          start: {
            line: 69,
            column: 14
          },
          end: {
            line: 69,
            column: 47
          }
        }],
        line: 69
      },
      "9": {
        loc: {
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 72,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 23
          },
          end: {
            line: 72,
            column: 31
          }
        }, {
          start: {
            line: 72,
            column: 34
          },
          end: {
            line: 72,
            column: 50
          }
        }],
        line: 72
      },
      "10": {
        loc: {
          start: {
            line: 83,
            column: 14
          },
          end: {
            line: 83,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 14
          },
          end: {
            line: 83,
            column: 57
          }
        }, {
          start: {
            line: 83,
            column: 14
          },
          end: {
            line: 83,
            column: 57
          }
        }],
        line: 83
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "a02c4029e7d2b595f9b2c25dc9e70a7f66c3faf2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _markdownTranslatable = require("markdown-translatable");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var useStyles = (cov_qln2pae0b.s[0]++, (0, _styles.makeStyles)(function (theme) {
  cov_qln2pae0b.f[0]++;
  cov_qln2pae0b.s[1]++;
  return {
    actions: {
      textAlign: 'right',
      paddingRight: "".concat(theme.spacing(1.5), "px"),
      width: '100%'
    },
    action: {
      marginLeft: "0px"
    }
  };
}));

function FileCard(_ref) {
  var authentication = _ref.authentication,
      repository = _ref.repository,
      file = _ref.file;
  cov_qln2pae0b.f[1]++;
  var classes = (cov_qln2pae0b.s[2]++, useStyles());

  var _ref2 = (cov_qln2pae0b.s[3]++, (0, _react.useState)(true)),
      _ref3 = _slicedToArray(_ref2, 2),
      preview = _ref3[0],
      setPreview = _ref3[1];

  var _ref4 = (cov_qln2pae0b.s[4]++, (0, _react.useState)(file ? (cov_qln2pae0b.b[0][0]++, file.content) : (cov_qln2pae0b.b[0][1]++, ''))),
      _ref5 = _slicedToArray(_ref4, 2),
      markdown = _ref5[0],
      setMarkdown = _ref5[1];

  var changed = (cov_qln2pae0b.s[5]++, markdown !== ((cov_qln2pae0b.b[1][0]++, file) && (cov_qln2pae0b.b[1][1]++, file.content)));
  var avatarUrl = (cov_qln2pae0b.s[6]++, (cov_qln2pae0b.b[2][0]++, repository.avatar_url) || (cov_qln2pae0b.b[2][1]++, repository.owner.avatar_url));
  var access = (cov_qln2pae0b.s[7]++, repository.permissions.push);
  cov_qln2pae0b.s[8]++;
  (0, _react.useEffect)(function () {
    cov_qln2pae0b.f[2]++;
    cov_qln2pae0b.s[9]++;
    setMarkdown((cov_qln2pae0b.b[3][0]++, file) && (cov_qln2pae0b.b[3][1]++, file.content));
  }, [file]);
  var branch = (cov_qln2pae0b.s[10]++, (cov_qln2pae0b.b[5][0]++, file) && (cov_qln2pae0b.b[5][1]++, file.branch) ? (cov_qln2pae0b.b[4][0]++, file.branch) : (cov_qln2pae0b.b[4][1]++, repository.default_branch));
  cov_qln2pae0b.s[11]++;
  return /*#__PURE__*/_react.default.createElement(_core.Card, null, /*#__PURE__*/_react.default.createElement(_core.CardHeader, {
    avatar: /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      src: avatarUrl
    }),
    title: /*#__PURE__*/_react.default.createElement("strong", null, (cov_qln2pae0b.b[6][0]++, file) && (cov_qln2pae0b.b[6][1]++, file.path)),
    subheader: repository.full_name + '/' + branch
  }), /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement(_core.Paper, null, /*#__PURE__*/_react.default.createElement(_markdownTranslatable.BlockEditable, {
    preview: preview,
    markdown: markdown,
    onEdit: setMarkdown,
    editable: !!authentication
  }))), /*#__PURE__*/_react.default.createElement(_core.CardActions, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.action,
    "aria-label": "Preview",
    onClick: function onClick() {
      cov_qln2pae0b.f[3]++;
      cov_qln2pae0b.s[12]++;
      return setPreview(!preview);
    }
  }, !preview ? (cov_qln2pae0b.b[7][0]++, /*#__PURE__*/_react.default.createElement(_icons.Pageview, null)) : (cov_qln2pae0b.b[7][1]++, /*#__PURE__*/_react.default.createElement(_icons.PageviewOutlined, null))), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.action,
    "aria-label": "Save",
    disabled: !access,
    onClick: function onClick() {
      cov_qln2pae0b.f[4]++;
      cov_qln2pae0b.s[13]++;

      if (changed) {
        cov_qln2pae0b.b[8][0]++;
        cov_qln2pae0b.s[14]++;
        file.save(markdown);
      } else {
        cov_qln2pae0b.b[8][1]++;
      }
    }
  }, changed ? (cov_qln2pae0b.b[9][0]++, /*#__PURE__*/_react.default.createElement(_icons.Save, null)) : (cov_qln2pae0b.b[9][1]++, /*#__PURE__*/_react.default.createElement(_icons.SaveOutlined, null))), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.action,
    "aria-label": "Delete",
    disabled: !access,
    onClick: function onClick() {
      cov_qln2pae0b.f[5]++;
      var confirmation = (cov_qln2pae0b.s[15]++, window.confirm("Are you sure you want to Delete ".concat(file.filepath, "?")));
      cov_qln2pae0b.s[16]++;

      if (confirmation) {
        cov_qln2pae0b.b[10][0]++;
        cov_qln2pae0b.s[17]++;
        file.dangerouslyDelete();
      } else {
        cov_qln2pae0b.b[10][1]++;
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.DeleteSweepOutlined, null)), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    title: "Close Repository",
    onClick: file.close
  }, /*#__PURE__*/_react.default.createElement(_icons.CancelOutlined, null)))));
}

;
cov_qln2pae0b.s[18]++;
FileCard.propTypes = {
  /** Repository tree_url can be used in place of blobConfig */
  repository: _propTypes.default.shape({
    owner: _propTypes.default.shape({
      username: _propTypes.default.string.isRequired,
      avatar_url: _propTypes.default.string.isRequired
    }),
    name: _propTypes.default.string.isRequired,
    avatar_url: _propTypes.default.string
  }).isRequired,

  /** Pass a previously returned file object to bypass the selection. */
  file: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    path: _propTypes.default.string.isRequired,
    sha: _propTypes.default.string.isRequired,
    content: _propTypes.default.string,
    branch: _propTypes.default.string,
    filepath: _propTypes.default.string
  }),

  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired
  })
};
var _default = FileCard;
exports.default = _default;